import { Injectable } from '@angular/core';
import { fromEvent } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EventsService {

  constructor() { }

  getUpdates(id: string) {
    return fromEvent<CustomEvent>(document, id);
  }

  emit(id: string, payload?: any) {
    document.dispatchEvent(new CustomEvent(id, { detail: payload }));
  }
}
